import { createReducer, on } from '@ngrx/store';
import { WorkshopState } from '@products/models/workshop.model';
import { ResetProductsActions } from '@store/products/product.actions';
import { WorkshopActions } from '@store/products/workshop/workshop.actions';

export { WorkshopState as State };

export const initialState: WorkshopState = {
  list: []
};

export const workshopReducer = createReducer(
  initialState,
  on(WorkshopActions.setInitialWorkshopProductList, (state, { workshopProductList }) => ({
    ...state,
    list: workshopProductList
  })),
  on(WorkshopActions.resetReducer, ResetProductsActions.resetWorkshopReducer, () => initialState)
);
